import React from 'react';
import './invite-and-earn.scss';
import Icon from '../Icon/Icon';
import { Link } from 'react-router-dom';
import { getDeviceType } from 'hb-redux-store/util/DeviceDetectionService';
import {
  DEVICE_TYPE,
  DEFAULT_REFERRAL_AMOUNT,
} from 'hb-redux-store/util/constantServices';

const InviteAndEarn = props => {
  const { redirectTo = '/my/vxl-point' } = props;
  let { iGet, source = '' } = props;
  const isMobileDevice = getDeviceType() === DEVICE_TYPE.MWEB;
  const ICON_SIZE = isMobileDevice ? (source ? 30 : 50) : 50;
  const ARROW_SIZE = isMobileDevice ? 10 : 15;
  if (!iGet || iGet === 0) iGet = DEFAULT_REFERRAL_AMOUNT;
  const OFFER_CTA = source
    ? `Invite & Earn ₹${iGet}`
    : `Invite and get ₹${iGet} each`;
  return (
    <div className={source ? 'invite-account' : 'invite'}>
      <div className={source ? 'invite-account--banner' : 'invite--banner'}>
        <div className="flex-align-items-center">
          <Icon class="icon-order-box-coins flex-shrink-0" size={ICON_SIZE} />
          <div
            className={
              source
                ? 'invite-account--banner--content'
                : 'invite--banner--content'
            }
          >
            <Link
              to={redirectTo}
              className="invite--banner--title flex-align-items-center"
            >
              <span>{OFFER_CTA}</span>
              <Icon class="icon-common-red-arrow-right" size={ARROW_SIZE} />
            </Link>
            {!source && (
              <div className="invite--banner--description">
                Bring a friend to VegXL and get &#8377;{iGet} each, credited to
                both of you.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default InviteAndEarn;
